import { call, put, takeLatest } from 'redux-saga/effects';
import api from '../../api/api';
import {
  paymentStatusSuccess,
  paymentStatusFailure
} from './payment-status-actions';
import {
	PAYMENT_STATUS_REQUEST
} from './payment-status-types';

// API call
function paymentStatusApi(paymentData) {
  return api.post('payment-status', paymentData)
    .catch((err) => {
      throw err;
    });
}

// Saga
function* paymentStatusSaga(action) {
  try {
    const response = yield call(paymentStatusApi, action.payload);
    yield put(paymentStatusSuccess(response.data));
  } catch (error) {
    yield put(paymentStatusFailure(error?.response?.data?.message || error.message || 'Payment status update failed'));
  }
}

// Root saga
export function* watchPaymentStatusSaga() {
  yield takeLatest(PAYMENT_STATUS_REQUEST, paymentStatusSaga);
}
